module.exports = __webpack_public_path__ + "static/Slowly-Two-2d7a19277f8fcd21225cbbf5705a5b00.ttf";